module.exports = __webpack_public_path__ + "static/media/redirect-slack.36e1eb10.svg";